module.exports = __webpack_public_path__ + "img/54.40e7191c.png";